import React from 'react';

export default function MonthYearFilterModal({ isOpen, onClose, onApply, currentFilter, setCurrentFilter }) {
  if (!isOpen) return null;

  const months = [
    'january', 'february', 'march', 'april', 'may', 'june',
    'july', 'august', 'september', 'october', 'november', 'december'
  ];

  const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);

  // Convert month name to display format (capitalized)
  const displayMonth = (month) => month.charAt(0).toUpperCase() + month.slice(1);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Filter by Date</h2>
          
          <div className="mb-4">
            <p className="block text-md font-semiold text-gray-800 mb-2">Month</p>
            <select
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              value={currentFilter.month}
              onChange={(e) => setCurrentFilter({...currentFilter, month: e.target.value})}
            >
              {months.map((month) => (
                <option key={month} value={month}>
                  {displayMonth(month)}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-6">
            <p className="block text-md font-semiold text-gray-800 mb-2">Year</p>
            <select
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              value={currentFilter.year}
              onChange={(e) => setCurrentFilter({...currentFilter, year: parseInt(e.target.value)})}
            >
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                onApply(currentFilter.month, currentFilter.year);
                onClose();
              }}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
            >
              Apply Filter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}